import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Exchange from '../components/Exchange';
import actions from '../redux/actions/price';
import notifyAction from '../redux/actions/notify';
import userActions from '../redux/actions/user';
import orderTransAction from '../redux/actions/order_transaction';
import orderBookAction from '../redux/actions/orderbook';

const mapStateToProps = (state) => ({
  price: state.price,
  setting: state.setting,
  user: state.user,
  book: state.orderBook,
});

const mapDispatchToProps = (dispatch) => ({
  onfetchAllLatestPriceAction: (params) => {
    dispatch(actions.fetchAllLatestPriceAction(params));
  },
  onfetchLatestPriceAction: (params) => {
    dispatch(actions.fetchLatestPriceAction(params));
  },
  onfetchPrice24hAction: (params) => {
    dispatch(actions.fetchPrice24hAction(params));
  },
  onfetchStickPriceAction: (params) => {
    dispatch(actions.fetchStickPriceAction(params));
  },
  onFetchUserBalances: (params) => {
    dispatch(userActions.fetchUserBalancesAction(params));
  },
  onfetchAllOrderTransactionAction: (params) => {
    dispatch(orderTransAction.fetchAllOrderTransactionAction(params));
  },
  onFetchAllOrderBookAction: (params) => {
    dispatch(orderBookAction.fetchAllOrderBookAction(params));
  },
  makeOrderBookEmpty: () => {
    dispatch(orderBookAction.makeOrderBookEmpty());
  },
});

// export const CandleStickChartContainer = connect(mapStateToProps, mapDispatchToProps)(CandleStickChart);
// export const StatisticBarContainer = connect(mapStateToProps, mapDispatchToProps)(StatisticBar);
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Exchange));
